import { ApolloProvider } from "@apollo/client";
import { client } from "./api/utils";
import Router from "./pages/router/Router";
import "./styles/app.scss";
import "./styles/fonts.scss";
import "./styles/variables.scss";

const App = () => {
  return (
    <ApolloProvider client={client}>
      <Router />
    </ApolloProvider>
  );
};

export default App;
